import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import Button from '../../../Button';

import { ISubmitButtom } from './types';

const SubmitButton: React.FC<ISubmitButtom> = props => {
  const { label, disabled } = props;
  const { submitForm } = useFormikContext();

  return (
    <StyledSubmitButton onClick={submitForm} disabled={disabled}>
      {label}
    </StyledSubmitButton>
  );
};

const StyledSubmitButton = styled(Button)``;

export default SubmitButton;
